import axios from "axios";

export default {
  search(query) {
    return axios
      .get("/api/trainees", {
        params: {
          per_page: query.perPage,
          current_page: query.currentPage,
          page: query.page,
          search: query.search,
          duplicates: query.duplicates
        }
      })
      .catch(error => {
        return error.response;
      });
  },
  exportTrainees(query) {
    return axios
      .get("/api/trainees/export", {
        responseType: "blob",
        params: {
          search: query.search,
          fields: query.fields
        }
      })
      .then(function(response) {
        return response;
      });
  },
  trainee(id) {
    return axios.get("/api/trainee/" + id);
  },
};

